import {History} from '../../../graphql-typings/graphql';
import {SimpleFunction} from './simple-function';
import {FunctionName} from './chart-function-types';

export class RoundFunction extends SimpleFunction {

  constructor() {
    super(FunctionName.RND, 'Round');
  }

  run(historyArray: History[]): History[] {
    return super.applySimpleFunction(Math.round, historyArray);
  }
}
